 
export class OpgaveAfsnit {
        public id: string;
        public overskrift: string;
        public indhold: string;
        public order: number;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/OpgaveAfsnit.ts